import P from 'bluebird';
import canUseDOM from 'exenv';

class CachingService {
  constructor() {
    this.cache = {};
  }

  initialize({ enabled = false, cacheClearInterval = 20000 }) {
    if (canUseDOM) {
      if (enabled) {
        this.cacheClearInterval = setInterval(
          function clearCache() {
            this.cache = {};
          }.bind(this),
          cacheClearInterval
        );
      }
    }
  }

  getAsync(key) {
    return P.resolve(this.cache[key]);
  }

  setex(key, expire, val) {
    this.cache[key] = val;
  }
}

export default new CachingService();



// WEBPACK FOOTER //
// ./src/client/services/caching_service.js